import {
  PLACE_USAGES_URL,
  OTHER_FILTEROPTIONS_URL,
} from "constants/url.constants";

export const getUsageOptions = async (lang = "fr") => {
  try {
    const url = new URL(PLACE_USAGES_URL);
    if (lang) {
      url.searchParams.append("lang", lang === "uk" ? "en" : lang); // Append language parameter
    }

    const response = await fetch(url);

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();

    if (data.success) {
      return data.data;
    }

    throw new Error("Failed to fetch usages");
  } catch (error) {
    console.error("Error fetching usages:", error);
    return [];
  }
};

export const getOtherFilterOptions = async ({
  text,
  lang, // Accept the language parameter
  page,
  perPage,
  from,
  to,
  lat,
  lng, 
  lat_p1,
  lat_p2,
  lng_p1,
  lng_p2,
  capacity,
  min_price,
  max_price,
  instant_booking,
  type,
  options = {},
  order,
  order_type,
  usages = [],
  price_type = [],
} = {}) => {
  // Create base query parameters only if values are provided
  const queryParams = new URLSearchParams();

  // Append only if values are present
  if (text) queryParams.append("text", text);
  if (lang) queryParams.append("lang", lang === "uk" ? "en" : lang); // Add language param
  // if (page) queryParams.append("page", page.toString());
  // if (perPage) queryParams.append("perPage", perPage.toString());
  if (lat) queryParams.append("lat", lat.toString()); // Fixed
  if (lng) queryParams.append("lng", lng.toString());
  if (lat_p1) queryParams.append("lat_p1", lat_p1.toString());
  if (lat_p2) queryParams.append("lat_p2", lat_p2.toString()); // Fixed
  if (lng_p1) queryParams.append("lng_p1", lng_p1.toString());
  if (lng_p2) queryParams.append("lng_p2", lng_p2.toString()); // Fixed
  if (from) queryParams.append("from", from);
  if (to) queryParams.append("to", to);
  if (capacity) queryParams.append("capacity", capacity.toString());
  if (min_price) queryParams.append("min_price", min_price.toString());
  if (max_price) queryParams.append("max_price", max_price.toString());
  if (price_type.length > 0) queryParams.append("price_type", price_type);
  if (instant_booking)
    queryParams.append("instant_booking", instant_booking.toString());
  if (type) queryParams.append("type", type);
  if (order) queryParams.append("order", order);
  if (order_type) queryParams.append("order_type", order_type);

  // Add usages if present
 const filteredUsages = usages.filter(usage => usage.trim() !== "");
if (filteredUsages.length > 0) {
    filteredUsages.forEach((usage) => queryParams.append("usages[]", usage));
}

  try {
    const response = await fetch(`${OTHER_FILTEROPTIONS_URL}?${queryParams}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();

    if (data.success) {
      return data.data;
    }

    throw new Error("Failed to fetch places");
  } catch (error) {
    console.error("Error fetching places:", error);
    return {
      placeTypes: [],
      parkings: [],
      meals: [],
      characteristics: [],
      openingHours: [],
      layouts: [],
    };
  }
};
